module.exports = __webpack_public_path__ + "media/images/flags/64/Trinidad-and-Tobago-9a23853d07bf350255790bb263168192.png";